<template>
  <div>
    <b-modal
      :id="`modal-cutoff-vehicle-${imei}`"
      class="mc-modal"
      :title="$t('controlTower.detail.cutOffVehicle')"
      header-bg-variant="primary"
      header-close-variant="light"
      hide-footer
      size="md"
      centered
    >
      <div
        v-for="(item, index) in filteredControls"
        :key="index"
        :class="['mc-control-tower__cutoff-vehicle', { 'mt-3': index !== 0 }]"
      >
        <b-row>
          <b-col md="4" class="d-flex align-items-center">
            <h6 class="teal-400 p-0 m-0">
              <i :class="item.icon"></i>
              {{ $t(item.label) }}
            </h6>
          </b-col>
          <b-col md="4">
            <McButton
              :text="$t('controlTower.modal.cutOff')"
              variant="secondary-red"
              size="sm"
              block
              @click="openModal(item.type, 'off')"
            />
          </b-col>
          <b-col md="4">
            <McButton
              :text="$t('controlTower.modal.switchOn')"
              variant="secondary"
              size="sm"
              block
              @click="openModal(item.type, 'on')"
            />
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal
      v-for="(status, key) in modals"
      :id="status.id"
      :key="key"
      class="mc-modal"
      :title="$t(status.title)"
      header-bg-variant="primary"
      header-close-variant="light"
      size="md"
      centered
    >
      <McAlert
        v-if="status.warning"
        variant="warning"
        :html="$t(status.warning)"
        withIcon
        :withGap="false"
      />
      <p class="mt-2 p-0">
        {{ $t(status.description) }}
      </p>
      <template #modal-footer>
        <McButton
          variant="secondary"
          class="me-2"
          :text="$t('global.action.cancel')"
          @click="$bvModal.hide(status.id)"
        />
        <McButton
          variant="primary"
          type="submit"
          :text="$t(status.action)"
          @click="sendCommand(status.command, status.type, status.id)"
        />
      </template>
    </b-modal>
  </div>
</template>

<script>
import McButton from '@/components/McButton'
import McAlert from '@/components/McAlert'
import { SET_ENGINE_STATUS } from '@/services/api/fleet'
import { mapGetters } from 'vuex'

export default {
  components: {
    McButton,
    McAlert,
  },
  props: {
    imei: {
      type: String,
      default: '',
    },
    sensor: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      controlsInfo: [
        {
          type: 'ignition',
          label: 'controlTower.modal.ignition',
          icon: 'mc-fa icon-fill_unlock',
        },
        {
          type: 'engine',
          label: 'controlTower.modal.engine',
          icon: 'mc-fa icon-fill_engine',
        },
      ],
      modals: {
        ignitionOff: {
          id: 'modal-cutoff-ignitionOff',
          title: 'controlTower.placeholder.ignitionOff',
          warning: 'controlTower.modal.ignitionOff',
          description: 'controlTower.modal.ignitionOffDesc',
          action: 'global.action.turnedOff',
          command: 'off',
          type: 'ignition',
        },
        ignitionOn: {
          id: 'modal-cutoff-ignitionOn',
          title: 'controlTower.placeholder.ignitionOn',
          description: 'controlTower.modal.ignitionOn',
          action: 'global.action.turnedOn',
          command: 'on',
          type: 'ignition',
        },
        engineOff: {
          id: 'modal-cutoff-engineOff',
          title: 'controlTower.placeholder.engineOff',
          warning: 'controlTower.modal.engineOff',
          description: 'controlTower.modal.engineOffDesc',
          action: 'global.action.turnedOff',
          command: 'off',
          type: 'engine',
        },
        engineOn: {
          id: 'modal-cutoff-engineOn',
          title: 'controlTower.placeholder.engineOn',
          description: 'controlTower.modal.engineOn',
          action: 'global.action.turnedOn',
          command: 'on',
          type: 'engine',
        },
      },
    }
  },
  computed: {
    ...mapGetters({
      cutOffSensorCodes: 'sensor/getCutOffSensorCodes',
      cutOffSensors: 'sensor/getCutOffSensors',
    }),
    controls() {
      return this.controlsInfo.map((info) => {
        const sensorCode = this.cutOffSensors[info.type]
        return {
          ...info,
          sensorCode,
        }
      })
    },
    filteredControls() {
      return this.controls.filter((control) => this.sensor.includes(control.sensorCode))
    },
  },
  methods: {
    openModal(type, command) {
      this.$bvModal.show(
        `modal-cutoff-${type}${command.charAt(0).toUpperCase() + command.slice(1)}`
      )
      this.$bvModal.hide('modal-cutoff-vehicle')
    },
    async sendCommand(command, type, modalId) {
      const input = {
        imei: this.imei,
        setEngineTo: command,
        type,
      }
      const res = await this.$apollo.mutate({
        mutation: SET_ENGINE_STATUS,
        fetchPolicy: 'no-cache',
        variables: {
          input: input,
        },
      })

      const statusKey = `${type.charAt(0).toUpperCase() + type.slice(1)}${
        command.charAt(0).toUpperCase() + command.slice(1)
      }`

      if (!res.data.setEngineStatus.isSuccessful) {
        this.$mcToast.error(this.$t(`controlTower.modal.fail${statusKey}`))
      } else {
        this.$mcToast.success(this.$t(`controlTower.modal.success${statusKey}`))
      }

      this.$bvModal.hide(modalId)
      this.$bvModal.hide('modal-cutoff-vehicle')
    },
  },
}
</script>
